/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanStatus/Content/Content/Action",
  isSubmitting
  
}) {
let treatmentCardIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'treatment_card',
})
let onClick = fromHelpers.useOnSubmit({
  children,
  viewPath,
  isSubmitting
  
})
let treatmentCardTxsTreatmentPlanActionValueData = fromData.useDataFormat({ viewPath,
context: 'treatment_card',
path: 'txs.treatment_plan_action',
format: fromHelpers.getButtonLabel,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 data="treatment_card"
 onClick={onClick}
 disabled={treatmentCardIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="treatment_card.txs.treatment_plan_action"
 format="helpers.js getButtonLabel"
 text={treatmentCardTxsTreatmentPlanActionValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}